import styles from "../../styles/sheet-upload.module.scss";
import { useState } from "react";
import { Upload } from "./Icons";

import classNames from "classnames/bind";
import { Button } from "./Button";
const css = classNames.bind(styles);

export const TextFileReader = ({
  onFileLoaded,
  allowedFiles,
  uploadedFile = false,
  saveDeliveryLimit,
  loading = false,
}) => {
  const [hasNewFile, setHasNewFile] = useState(false);

  const handleSetFile = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const extension = file.name.split(".").pop()?.toLowerCase();

    if (extension !== "kml") {
      alert({
        text: "Arquivo inválido. Por favor, selecione um arquivo .kml.",
      });
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (readerEvent) => {
      const content = readerEvent.target?.result;
      if (typeof content === "string") {
        onFileLoaded({
          name: file.name,
          content,
        });
        setHasNewFile(true);
      }
    };

    reader.readAsText(file);
  };

  return (
    <>
      <label htmlFor="upload" className={css({ upload: true, hasNewFile })}>
        <div className={styles.icon}>
          <Upload color={hasNewFile ? "#6161ff" : "#4C4C4C"} />
        </div>

        <div className={styles.selectFile}>
          <p>
            {hasNewFile || uploadedFile
              ? "Carregar outro arquivo"
              : "Clique aqui"}
          </p>
          {!uploadedFile && <span>para fazer upload de arquivos</span>}
        </div>

        <span className={styles.fileAccepted}>
          Tipo do arquivo aceito: .kml
        </span>
        <input
          type="file"
          id="upload"
          accept={allowedFiles || "text/*"}
          onChange={(e) => handleSetFile(e)}
        />
      </label>

      {hasNewFile && (
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            loading={loading}
            disabled={loading}
            onClick={saveDeliveryLimit}
          >
            Salvar
          </Button>
        </div>
      )}
    </>
  );
};
